export const LoadingSpinner = () => (
	<div className="flex justify-center items-center h-64">
		<div className="relative w-24 h-24">
			<div className="absolute top-0 left-0 right-0 bottom-0">
				<svg
					className="animate-spin h-24 w-24"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24"
				>
					<defs>
						<linearGradient id="spinner-gradient" x1="1" y1="0" x2="0" y2="1">
							<stop offset="0%" stopColor="#4f35e1" />
							<stop offset="100%" stopColor="#14b8a6" />
						</linearGradient>
					</defs>
					<circle
						className="opacity-25"
						cx="12"
						cy="12"
						r="10"
						stroke="url(#spinner-gradient)"
						strokeWidth="4"
						fill="none"
					></circle>
					<path
						className="opacity-75"
						fill="url(#spinner-gradient)"
						d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
					></path>
				</svg>
			</div>
		</div>
	</div>
);
